import { format } from 'date-fns';
import type { FormAnswer } from './lead-form-response';

export const formatSubmittedAt = (value: string | null, pattern: string) =>
  value ? format(new Date(value), pattern) : null;

export const answeredValues = (answer: FormAnswer) =>
  answer.values.filter((v) => v.trim() !== '');

/** Fall back to a readable field name when question wording is unavailable. */
export function humaniseKey(key: string): string {
  const words = key.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : key;
}

export function QuestionLabel({ answer }: { answer: FormAnswer }) {
  return <>{answer.label ?? humaniseKey(answer.key)}</>;
}

export function AnswerValue({ answer }: { answer: FormAnswer }) {
  const values = answeredValues(answer);
  if (values.length === 0) {
    return (
      <span className="text-muted-foreground italic">
        {answer.status === 'missing' ? 'No answer on record' : 'Not answered'}
      </span>
    );
  }
  if (values.length === 1) {
    return <span className="whitespace-pre-wrap break-words">{values[0]}</span>;
  }
  return (
    <ul className="flex flex-wrap gap-1.5">
      {values.map((value, index) => (
        <li
          key={index}
          className="min-w-0 max-w-full whitespace-pre-wrap break-words rounded-lg border border-primary/10 bg-primary/5 px-2.5 py-1 text-primary text-sm leading-snug"
        >
          {value}
        </li>
      ))}
    </ul>
  );
}
